import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEmailSignature } from 'hooks/useEmailSignature';
import { useUserContext } from 'providers/UserProvider';
import strings from 'strings';
import { BulkDrawerFormFieldsMap } from 'UI/components/organisms/BulkEmailForm/fields';

import { getAttemptsFormValues } from '../BulkSequences.utils';
import { FIRST_STEP_ORDINAL } from '../constants';

export const useSequencesPreviewSections = () => {
  const { watch } = useFormContext();
  const [currentUser] = useUserContext();
  const { signature } = useEmailSignature();

  const searchProject = watch(BulkDrawerFormFieldsMap.To.key);
  const subject = watch(BulkDrawerFormFieldsMap.Subject.key);
  const emailBody = watch(BulkDrawerFormFieldsMap.EmailBody.key);
  const attemptsWatchers = getAttemptsFormValues(watch);

  const from = useMemo(
    () => `${currentUser.personalInformation?.full_name ?? ''} - ${currentUser.email}`,
    [currentUser]
  );

  const sections = useMemo(() => {
    const finalSignature = signature || '';
    const initialTo = searchProject ? `${searchProject.name} (${searchProject.bulkableItems})` : '';
    const finalSections = [];
    const shouldSetInitialSection = subject && emailBody && from;

    if (shouldSetInitialSection) {
      finalSections.push({
        emailBody: `${emailBody}${finalSignature}`,
        from,
        key: FIRST_STEP_ORDINAL,
        subject,
        to: initialTo
      });
    }

    Object.entries(attemptsWatchers || {}).forEach(([key, attempt]) => {
      finalSections.push({
        ...attempt,
        emailBody: `${attempt?.emailBody}${finalSignature}`,
        from,
        key,
        to: strings.bulkEmails.forms.sequences.preview.searchProjectDefaultLabel
      });
    });

    return finalSections;
  }, [attemptsWatchers, emailBody, from, searchProject, signature, subject]);

  return sections;
};
